import React from "react";
import { Control, FieldValues, Path } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

/** Event.preEpStep values; "none" is the select's stand-in for null. */
export const PRE_EP_STEP_OPTIONS = [
  { value: "none", label: "None" },
  { value: "executive_perspective", label: "Executive Perspective" },
  { value: "welcome_session", label: "Group Welcome Session" },
  {
    value: "support_session",
    label: "Group Follow Up and Support Session",
  },
] as const;

export type PreEpStepValue =
  | "executive_perspective"
  | "welcome_session"
  | "support_session";

/**
 * Marks an event as one a Pre-EP member registers for from a getting-started
 * step ("Register for EP" / "Register for your welcome session"). Several
 * events can share a step, e.g. the online and in-person EP.
 */
export function PreEpStepField<T extends FieldValues>({
  control,
  name,
}: {
  control: Control<T>;
  name: Path<T>;
}) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="rounded-lg border border-gray-200 dark:border-slate-700 p-4 bg-white dark:bg-slate-800">
          <FormLabel className="text-base">
            Pre-EP getting-started step
          </FormLabel>
          <p className="text-xs text-gray-500 dark:text-gray-400 mb-2">
            Offer this event on a Pre-EP member&apos;s getting-started page.
            Members pick from every published event marked with the same step,
            then a session.
          </p>
          <Select
            onValueChange={(value) =>
              field.onChange(value === "none" ? null : value)
            }
            value={field.value ?? "none"}
          >
            <FormControl>
              <SelectTrigger className="bg-white dark:bg-slate-800 dark:border-slate-700">
                <SelectValue />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {PRE_EP_STEP_OPTIONS.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FormItem>
      )}
    />
  );
}
